// 使用jszip
// import JSZip from 'jszip'
import { getFileName } from '@com/utils/file'
import i18n from '@/lang'

// 通过url获得文件数据
export function validateCocosModelFileType(resource: any, file: any) {
  const resourceFiles = cocosModelZipByResource(resource)
  const fileNames = resourceFiles.map((item: any) => getFileName(item))
  if (resourceFiles.length !== file.length) {
    // 文件数量不匹配
    return {
      validate: false,
      msg: i18n.t('playTurbo.whole.common.model.cocos.rule.filenum'),
    }
  }
  // 必须包含所有文件格式，并且命名一致
  if (
    !fileNames.every((name) =>
      file.some((item) => item.toLowerCase().endsWith(name.toLowerCase())),
    )
  ) {
    return {
      validate: false,
      msg: i18n.t('playTurbo.whole.common.model.cocos.rule.name'),
    }
  }
  return { validate: true }
}

function cocosModelZipByResource(resource: any) {
  const file = [resource.extra.origin_file_url] // 默认fbx文件
  resource.preview_urls.forEach((item: any) => {
    if (item.toLowerCase().endsWith('.jpg')) {
      file.push(item)
    } else if (item.toLowerCase().endsWith('.png')) {
      file.push(item)
    }
  })
  return file
}
